import React from 'react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

interface GoogleAiVoiceUnavailableProps {
  message: string;
  onRetry: () => void;
  retrying: boolean;
}

export default function GoogleAiVoiceUnavailable({ message, onRetry, retrying }: GoogleAiVoiceUnavailableProps) {
  return (
    <Box sx={{ width: '100%', height: '100%', minHeight: 320, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 2 }}>
      <Box sx={{ width: '100%', maxWidth: 720, display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Typography variant='body1' fontWeight={500}>
          AI Voice is temporarily unavailable
        </Typography>
        <Alert severity='warning'>{message}</Alert>
        <Box>
          <Button variant='contained' onClick={onRetry} disabled={retrying}>
            {retrying ? 'Retrying...' : 'Retry'}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
